export default {
  budget: 'Orçamento',
  upTo: 'até {value}',
  restrictions: 'Restrições',
  customizations: 'Personalizações',
  spendIn: 'Gasto em',
  and: 'e',
  predictedSales: '{kpi} projetadas',
  runningSimulation: 'Executando simulação...',
  createdBy: 'Criado por',
  on: 'em',
  modelVersion: 'Versão do modelo:',
  clone: 'Clonar',
  compare: 'Comparar',
  edit: 'Editar',
  delete: 'Excluir',
  printJsonToConsole: 'Imprimir JSON no console',
  viewMore: 'Ver mais',
  warning: 'Aviso',
  deletingSimulation: 'Excluindo a simulação:',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  cancel: 'Cancelar',
  unrestricted: 'Sem restrições',
  moreThan: 'Mais de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exatamente',
  settings: 'Configurações',
  showToExternalUsers: 'Mostrar para usuários externos',
  save: 'Salvar',
  noPreviewAvailable: 'Este modelo não tem uma pré-visualização combinada',
  noPreviewReasonOutputs: 'Seus resultados são reportados separadamente para {outputs}, e esses KPIs não podem ser somados em um único valor ou gráfico.',
  noPreviewReasonGeneric: 'Este modelo reporta cada KPI separadamente, portanto eles não podem ser somados em um único valor ou gráfico.',
  noPreviewViewMore: 'Clique em "Ver mais" para revisar cada KPI separadamente.',
  kpiWeighting: 'Ponderação de KPI',
  kpiAutoBalance: 'Auto-Balance',
  timeRestrictions: 'Restrições de tempo',
  allChannels: 'Todos os Canais',
  fullPeriod: 'Período Completo'
}
